import { UntypedFormGroup } from '@angular/forms';
import { LoginFooterData } from '../../../shared/login-footer/modals/login-footer.interface';
import { LoginHeaderContent } from '../../../shared/login-header/models/login-header.interface';
import { NextDisplayView } from '../../login-authentication-screen/models/login-credentials.interface';

export interface ResetPasswordContent {
  formGroup: UntypedFormGroup;
  formAttributes: ResetPasswordFormAttributes;
  pageContent: ResetPasswordPageContent;
  hasError: boolean;
  errorMessage: string;
}

export interface ResetPasswordPageContent {
  firstNameLabel: string;
  firstNameText: string;
  forgotLogin: string;
  headerSubTitle: string;
  headerTitle: string;
  lastNameLabel: string;
  lastNameText: string;
  nextDisplayView: NextDisplayView;
  userIdLabel: string;
  userIdText: string;
  viewName: string;
  pageHeader: LoginHeaderContent;
  errors: ResetPasswordErrorMessages;
  buttonLabel: string;
  footer?: LoginFooterData;
  srText?: string;
  mfaFailed?: boolean;
}

export interface ResetPasswordErrorMessages {
  userIdErrorMessage: string;
  firstNameErrorMessage: string;
  lastNameErrorMessage: string;
  alertWarning: string;
}

export interface ResetPasswordFormAttributes {
  errorCount: number;
  submitAttempt?: boolean;
  errorAlertBanner: boolean;
  isEmail: boolean;
  isMfa: boolean;
  userIdControlTouched: boolean;
  firstNameControlTouched: boolean;
  lastNameControlTouched: boolean;
  disableActionButton: boolean;
}
